import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MainDomainI} from "../../custom-domain.interface";

@Component({
    selector: 'db-custom-domain-generated',
    templateUrl: './custom-domain-generated.component.html',
    styleUrl: './custom-domain-generated.component.scss',
    standalone: false
})
export class CustomDomainGeneratedComponent {
  @Input() domain: MainDomainI;
  @Input() pointed: boolean;
  @Output() troubleshootDomaine  = new EventEmitter<void>();
  @Output() openNameservers  = new EventEmitter<void>();
  @Input() troubleshootDomaineLoading  = false;
}
